import {Alea} from './random';
import {lerp, createElement} from './utils';

const {sin, cos, PI} = Math;

export function createStamp(size, type=0) {
    let random = Alea('stamp');
    let canvas = createElement('canvas', {width: size, height: size});
    // let canvas = window.OffscreenCanvas ?
    //     new OffscreenCanvas(size, size) :
    //     createElement('canvas', {width: size, height: size});
    // let canvas = createElement('canvas', {
    //     width: size,
    //     height: size,
    //     style: `
    //         position: absolute;
    //         bottom: 0;
    //         left: 0;
    //         z-index: 20;
    //     `,
    // });
    let ctx = canvas.getContext('2d');

    ctx.fillStyle = 'white';
    //ctx.fillStyle = 'black';

    for (let i = 0; i < 3e3; ++i) {
        let theta = random() * 2 * PI;
        let rr = lerp(1, 5, random() ** 2);
        let r = (random() ** .3) * size/2 - rr;
        let aspect = .9;
        let x = size/2 + aspect * r * cos(theta);
        let y = size/2 + r * sin(theta);
        ctx.globalAlpha = lerp(0.1, 0.7, random());
        ctx.beginPath();
        ctx.arc(x, y, rr, 0, 2*PI);
        ctx.closePath();
        ctx.fill();
    }

    return canvas;
}

